import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBlackberryComponent } from './simple-icons-blackberry.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBlackberryComponent ],
    exports:      [ SimpleIconsBlackberryComponent ],
    bootstrap:    []
})
export class SimpleIconsBlackberryModule {}
